import {ADVERTISEMENT_CONSTS} from "../constants";

export const initialState = {
    advertisements:[]
};

export default (state = initialState, action) => {
    switch (action.type) {
        case ADVERTISEMENT_CONSTS.GET_ADVERTISEMENTS:
            return {
                ...state,
                advertisements: action.payload || [],
            };
        case ADVERTISEMENT_CONSTS.DELETE_ADVERTISEMENT_BY_ID:
            return {
                ...state,
                advertisements: state.advertisements.filter(item => item.id !== action.payload)

            };
        default:
            return state;
    }
}
